import 'css-chunksrc/client/scenes/preferences/notifications/styles.scss';export default {
  "notifications": "_notifications_qpa6f_1",
  "group": "_group_qpa6f_5",
  "checkbox": "_checkbox_qpa6f_14",
  "formWrapper": "_formWrapper_qpa6f_19",
  "label": "_label_qpa6f_23"
};